import { useCallback, useState } from "react";
import type { U3130ExportDepensesParSemaineParCodePdfRequest } from "./U3130Service";

export interface UseU3130ExportDepensesParSemaineParCodePdfHandlersProps {
  doExportDepensesParSemaineParCodePdfFn: (body: U3130ExportDepensesParSemaineParCodePdfRequest) => Promise<unknown>;
  onSuccess: () => void;
  onError: (params: { error: unknown }) => void;
}

export function useU3130ExportDepensesParSemaineParCodePdfHandlers({
  doExportDepensesParSemaineParCodePdfFn,
  onSuccess,
  onError,
}: UseU3130ExportDepensesParSemaineParCodePdfHandlersProps) {
  const [isExporting, setIsExporting] = useState(false);

  const exportDepensesParSemaineParCodePdf = useCallback(
    async (body: U3130ExportDepensesParSemaineParCodePdfRequest) => {
      if (!body.startDate?.trim() || !body.endDate?.trim()) return;
      setIsExporting(true);
      try {
        await doExportDepensesParSemaineParCodePdfFn(body);
        onSuccess();
      } catch (error: unknown) {
        onError({ error });
      } finally {
        setIsExporting(false);
      }
    },
    [doExportDepensesParSemaineParCodePdfFn, onSuccess, onError],
  );

  return { exportDepensesParSemaineParCodePdf, isExporting };
}
